document.addEventListener('DOMContentLoaded', () => {
  setHomeShopHeaderHeight();
  initAllHomeShopProducts();
});
window.addEventListener('load', () => {
  setHomeShopHeaderHeight();
});
window.addEventListener('resize', debounceHomeShop(() => {
  setHomeShopHeaderHeight();
}, 100));
document.addEventListener('shopify:section:load', (event) => {
  setHomeShopHeaderHeight();
  const section = event.target.querySelector('[data-home-shop-products]');
  if (section) {
    initHomeShopProducts(section);
  }
});
function setHomeShopHeaderHeight() {
  const header = document.querySelector('.custom-header.custom-header--fixed');
  if (!header) {
    document.documentElement.style.setProperty('--home-shop-header-height', '0px');
    return;
  }
  const headerHeight = header.getBoundingClientRect().height;
  document.documentElement.style.setProperty('--home-shop-header-height', `${headerHeight}px`);
}
function initAllHomeShopProducts() {
  document.querySelectorAll('[data-home-shop-products]').forEach((section) => {
    initHomeShopProducts(section);
  });
}
function initHomeShopProducts(section) {
  if (section.dataset.shopInitialized === 'true') {
    return;
  }
  section.dataset.shopInitialized = 'true';
  const slides = Array.from(section.querySelectorAll('[data-shop-slide]'));
  const prevButton = section.querySelector('[data-shop-prev]');
  const nextButton = section.querySelector('[data-shop-next]');
  const currentCounter = section.querySelector('[data-shop-current]');
  const totalCounter = section.querySelector('[data-shop-total]');
  const progress = section.querySelector('[data-shop-progress]');
  const autoplayEnabled = section.dataset.autoplay === 'true';
  const autoplaySpeed = Number(section.dataset.autoplaySpeed) || 6000;
  if (slides.length === 0) {
    return;
  }
  let currentIndex = 0;
  let autoplayTimer = null;
  let touchStartX = 0;
  let touchStartY = 0;
  let touchEndX = 0;
  let isHorizontalSwipe = false;
  let swipeDirectionDecided = false;
  let pointerStartX = 0;
  let pointerEndX = 0;
  let isPointerDown = false;
  let parallaxFrame = null;
  const formatNumber = (number) => {
    return String(number).padStart(2, '0');
  };
  const updateProgress = () => {
    if (currentCounter) {
      currentCounter.textContent = formatNumber(currentIndex + 1);
    }
    if (totalCounter) {
      totalCounter.textContent = formatNumber(slides.length);
    }
    if (progress) {
      const percentage = ((currentIndex + 1) / slides.length) * 100;
      progress.style.width = `${percentage}%`;
    }
  };
  const resetParallax = () => {
    section.style.setProperty('--product-parallax-x', '0px');
    section.style.setProperty('--product-parallax-y', '0px');
  };
  const showSlide = (index) => {
    if (index < 0) {
      index = slides.length - 1;
    }
    if (index >= slides.length) {
      index = 0;
    }
    currentIndex = index;
    resetParallax();
    slides.forEach((slide, slideIndex) => {
      const isActive = slideIndex === currentIndex;
      slide.classList.toggle('is-active', isActive);
      slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });
    updateProgress();
  };
  const nextSlide = () => {
    showSlide(currentIndex + 1);
  };
  const prevSlide = () => {
    showSlide(currentIndex - 1);
  };
  const stopAutoplay = () => {
    if (autoplayTimer) {
      clearInterval(autoplayTimer);
      autoplayTimer = null;
    }
  };
  const startAutoplay = () => {
    if (!autoplayEnabled || slides.length <= 1) {
      return;
    }
    stopAutoplay();
    autoplayTimer = setInterval(() => {
      nextSlide();
    }, autoplaySpeed);
  };
  const restartAutoplay = () => {
    stopAutoplay();
    startAutoplay();
  };
  const handleSwipe = (startX, endX) => {
    const difference = startX - endX;
    if (Math.abs(difference) < 50) {
      return;
    }
    if (difference > 0) {
      nextSlide();
    } else {
      prevSlide();
    }
    restartAutoplay();
  };
  const handleParallax = (event) => {
    if (window.innerWidth < 750 || isPointerDown) {
      return;
    }
    if (parallaxFrame) {
      cancelAnimationFrame(parallaxFrame);
    }
    parallaxFrame = requestAnimationFrame(() => {
      const rect = section.getBoundingClientRect();
      const normalizedX = ((event.clientX - rect.left) / rect.width) - 0.5;
      const normalizedY = ((event.clientY - rect.top) / rect.height) - 0.5;
      const moveX = normalizedX * 18;
      const moveY = normalizedY * 12;
      section.style.setProperty('--product-parallax-x', `${moveX}px`);
      section.style.setProperty('--product-parallax-y', `${moveY}px`);
    });
  };
  if (nextButton) {
    nextButton.addEventListener('click', () => {
      nextSlide();
      restartAutoplay();
    });
  }
  if (prevButton) {
    prevButton.addEventListener('click', () => {
      prevSlide();
      restartAutoplay();
    });
  }
  section.addEventListener('mousemove', handleParallax);
  section.addEventListener('touchstart', (event) => {
    if (event.touches.length !== 1) return;
    touchStartX = event.touches[0].clientX;
    touchStartY = event.touches[0].clientY;
    touchEndX = touchStartX;
    isHorizontalSwipe = false;
    swipeDirectionDecided = false;
  }, { passive: true });
  section.addEventListener('touchmove', (event) => {
    if (event.touches.length !== 1) return;
    const deltaX = event.touches[0].clientX - touchStartX;
    const deltaY = event.touches[0].clientY - touchStartY;
    if (!swipeDirectionDecided && Math.max(Math.abs(deltaX), Math.abs(deltaY)) > 8) {
      swipeDirectionDecided = true;
      isHorizontalSwipe = Math.abs(deltaX) > Math.abs(deltaY);
    }
    if (isHorizontalSwipe && event.cancelable) {
      event.preventDefault();
    }
  }, { passive: false });
  section.addEventListener('touchend', (event) => {
    if (isHorizontalSwipe && event.changedTouches.length) {
      touchEndX = event.changedTouches[0].clientX;
      handleSwipe(touchStartX, touchEndX);
    }
    isHorizontalSwipe = false;
    swipeDirectionDecided = false;
  }, { passive: true });
  section.addEventListener('touchcancel', () => {
    isHorizontalSwipe = false;
    swipeDirectionDecided = false;
  }, { passive: true });
  section.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'mouse') {
      return;
    }
    if (event.target.closest('a, button')) {
      return;
    }
    isPointerDown = true;
    pointerStartX = event.clientX;
    pointerEndX = event.clientX;
    section.classList.add('is-dragging');
  });
  section.addEventListener('pointermove', (event) => {
    if (!isPointerDown) {
      return;
    }
    pointerEndX = event.clientX;
  });
  section.addEventListener('pointerup', () => {
    if (!isPointerDown) {
      return;
    }
    isPointerDown = false;
    section.classList.remove('is-dragging');
    handleSwipe(pointerStartX, pointerEndX);
  });
  section.addEventListener('pointercancel', () => {
    isPointerDown = false;
    section.classList.remove('is-dragging');
  });
  section.addEventListener('mouseenter', stopAutoplay);
  section.addEventListener('mouseleave', () => {
    isPointerDown = false;
    section.classList.remove('is-dragging');
    resetParallax();
    startAutoplay();
  });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      stopAutoplay();
    } else {
      startAutoplay();
    }
  });
  showSlide(0);
  startAutoplay();
}
function debounceHomeShop(callback, delay) {
  let timeout;
  return function () {
    clearTimeout(timeout);
    timeout = setTimeout(callback, delay);
  };
}
